import { http } from 'utils'
import { merge } from 'lodash'
import Vue from 'vue'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

Pusher.logToConsole = process.env.NODE_ENV !== 'production'

export default {
  connect () {
    const options = merge({
      broadcaster: 'pusher',
      key: process.env.PUSHER_KEY,
      authorizer (channel, options) {
        return {
          authorize (socket, callback) {
            http.post('broadcasting/auth', { 'socket_id': socket, 'channel_name': channel.name })
              .then((response) => {
                callback(null, response.data)
              })
              .catch(callback)
          }
        }
      },
      namespace: 'Pickstar.Events',
      cluster: process.env.PUSHER_CLUSTER || 'ap1'
    }, {})

    Vue.prototype.$echo = new Echo(options)
  },

  disconnect () {
    if (Vue.prototype.$echo) {
      Vue.prototype.$echo.disconnect()
    }
  }
}
